import type { CountLiveCircuits } from "./types";

export const countLiveCircuits: CountLiveCircuits = ({ edit }) => {
  const routedIds = Object.entries(edit.derivedGeometry?.byCircuit ?? {})
    .filter(([, state]) => state.paths.length)
    .map(([circuitId]) => circuitId);
  const feeders = routedIds.filter((circuitId) => edit.feederCircuits[circuitId]).length;
  return { circuits: routedIds.length - feeders, feeders };
};
